import _ from '../../../util/underscore-wrapper';
import Keys from '../../../util/Keys';
import 'vendor/plugins/jquery.custominput';
import BaseInput from '../BaseInput';
import hbs from 'handlebars-inline-precompile';

export default BaseInput.extend({
  template: hbs`
    <input type="checkbox" name="{{name}}" id="{{inputId}}"/>
    <label for="{{inputId}}" data-se-for-name="{{name}}">{{placeholder}}</label>
  `,
  /**
   * @Override
   */
  events: {
    'change :checkbox': 'update',
    keyup: function (e) {
      if (Keys.isSpaceBar(e)) {
        this.$(':checkbox').click();
      } else if (Keys.isEnter(e)) {
        this.model.trigger('form:save');
      }
    }
  },

  /**
   * @Override
   */
  editMode: function () {
    let placeholder = _.resultCtx(this.options, 'placeholder', this);

    if (placeholder === '') {
      placeholder = _.resultCtx(this.options, 'label', this);
    } else if (placeholder === false) {
      placeholder = '';
    }

    this.$el.html(this.template(_.extend(_.omit(this.options, 'placeholder'), { placeholder: placeholder })));
    const $input = this.$(':checkbox');

    $input.prop('checked', this.getModelValue() || false);

    this.$('input').customInput();
    this.model.trigger('form:resize');

    return this;
  },

  /**
   * @Override
   */
  readMode: function () {
    this.editMode();
    this.$(':checkbox').prop('disabled', true);
    return this;
  },

  /**
   * @Override
   */
  val: function () {
    return this.$(':checkbox').prop('checked');
  },

  /**
   * @Override
   */
  focus: function () {
    return this.$(':checkbox').focus();
  }
});



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/inputs/CheckBox.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/inputs/CheckBox.js